// extracted by mini-css-extract-plugin
module.exports = {"Container":"MetadataLabel_Container__scXpI"};